import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect, useRef, useState } from 'react';
import Icon from './app-icon180x180.png';

// Icon size between 0 and 100
const PERCENT_ICON_SIZE = 25;

/**
 * Renders a QR code component with customizable value with Network App icon in the center
 *
 * @param {object} props - The properties object containing value, size, onElementChange, and otherProps
 * @return {JSX.Element} The rendered QR code component
 */
function NWA_QRCode(props) {
    const {
            value = 'https://get.networkapp.com',
            size = 128,
            logo = true,
            onElementChange,
            ...otherProps
        } = props,
        [currentCanvas, setCurrentCanvas] = useState(null),
        imageSettings = logo
            ? {
                  src: Icon,
                  width: (PERCENT_ICON_SIZE / 100) * size,
                  height: (PERCENT_ICON_SIZE / 100) * size,
              }
            : null,
        ref = useRef();

    useEffect(() => {
        const canvas = ref.current?.querySelector('canvas');
        setCurrentCanvas((currentCanvas) =>
            currentCanvas !== canvas ? canvas : currentCanvas
        );
    });

    useEffect(() => {
        if (onElementChange) {
            onElementChange(currentCanvas);
        }
    }, [currentCanvas]);

    return (
        <div ref={ref}>
            <QRCodeCanvas
                value={value}
                size={size}
                imageSettings={imageSettings}
                {...otherProps}
            />
        </div>
    );
}

export default NWA_QRCode;
